import { useQuery } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { aceAssignmentKeys } from '../../cache-keys/aceAssignmentKeys';

export function useGetAssignmentApplicationV3(
  applicationId: string,
  options?: { enabled?: boolean },
) {
  const api = useAPI();

  return useQuery({
    queryKey: [aceAssignmentKeys.application(applicationId)],
    queryFn: () =>
      ace_api.getAssignmentApplicationV3(api)({ ApplicationID: applicationId }),
    enabled:
      applicationId !== '' && api.token !== '' && (options?.enabled ?? true),
  });
}
